<template>
  <div id="app">
    <Title v-show="$route.meta.isTitleShow" />
    <div class="contain">
      <transition name="fade" mode="out-in">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </transition>
      <transition name="fade" mode="out-in">
        <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view>
      </transition>
    </div>
    <div class="tabbar" v-show="$route.meta.isShow">
      <van-tabbar
        v-model="active"
        :route="true"
        inactive-color="#333333"
        active-color="#93683D"
      >
        <van-tabbar-item to="/home">
          <span>首页</span>
          <template #icon="props">
            <img :src="props.active ? icon.active1 : icon.inactive1" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/article">
          <span>文章</span>
          <template #icon="props">
            <img :src="props.active ? icon.active2 : icon.inactive2" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/order">
          <span>订单</span>
          <template #icon="props">
            <img :src="props.active ? icon.active3 : icon.inactive3" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/personal">
          <span>个人中心</span>
          <template #icon="props">
            <img :src="props.active ? icon.active4 : icon.inactive4" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>
<script>
import Title from "./components/Title";
export default {
  components: {
    Title,
  },
  data() {
    return {
      active: 0,
      icon: {
        active1: require("../src/assets/img/tabbar_img/tab_home_pre@2x.png"),
        inactive1: require("../src/assets/img/tabbar_img/tab_home@2x.png"),
        active2: require("../src/assets/img/tabbar_img/tab_article_pre@2x.png"),
        inactive2: require("../src/assets/img/tabbar_img/tab_article@2x.png"),
        active3: require("../src/assets/img/tabbar_img/tab_order_pre@2x.png"),
        inactive3: require("../src/assets/img/tabbar_img/tab_order@2x.png"),
        active4: require("../src/assets/img/tabbar_img/tab_personal_pre@2x.png"),
        inactive4: require("../src/assets/img/tabbar_img/tab_personal@2x.png"),
      },
    };
  },
  watch: {
    $route: function () {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      const oScript = document.createElement("script");
      oScript.type = "text/javascript";
      oScript.src = this.commonRealmName + "/index.php/api/wxshare";
      document.head.appendChild(oScript);
    },
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },
  created() {
    //链接有aid截取保存
    if (!localStorage.getItem("aid")) {
      if (window.location.href.split("?aid=")[1]) {
        let href = this.showWindowHref();
        localStorage.setItem("aid", parseInt(href.aid));
      }
    }
  },
  methods: {
    //获取url query 拼接 参数
    showWindowHref() {
      var sHref = window.location.href;
      var args = sHref.split("?");
      if (args[0] == sHref) {
        return "";
      }
      var arr = args[1].split("&");
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        var arg = arr[i].split("=");
        obj[arg[0]] = arg[1];
      }
      return obj;
    },
  },
};
</script>
<style lang="scss" scoped>
#app {
  display: flex;
  justify-content: space-between;
  min-height: 100%;
  .contain {
    flex: 1;
    width: 100%;
  }
}
.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.49rem;

  box-shadow: 0 0 0.05rem 0 rgba(0, 0, 0, 0.08);
  img {
    width: 0.22rem;
    height: 0.22rem;
  }
  .van-tabbar--fixed {
    height: 0.49rem;
  }

  .van-tabbar-item {
    span {
      display: block;
      transform: scale(0.8);
      font-size: 0.125rem;
    }
  }
}
</style>
